import { BULK_UPDATE_FAILURE_ALERT } from '../constants/AlertTypes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ConnectedRefreshLink from '../components/ConnectedRefreshLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const getBulkUpdateFailureAlert = () => ({
  id: BULK_UPDATE_FAILURE_ALERT,
  type: 'danger',
  closeable: false,
  titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "ConversationsInboxUI.threadBatchOperations.bulkUpdateFailedAlert.title"
  }),
  message: /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "ConversationsInboxUI.threadBatchOperations.bulkUpdateFailedAlert.message",
      options: {
        refreshLink: /*#__PURE__*/_jsx(ConnectedRefreshLink, {})
      }
    })
  })
});